<div class="div-button">
  <tds-button
    type="button"
    variant="{{ variant }}"
    size="{{ size }}"
    text="{{ text }}"
    animation="none"
    [disabled]="disabled"
    (click)="click()"
  >
    @if (icon) {
      <tds-icon slot="icon" size="20px" name="{{ icon }}"></tds-icon>
    }
  </tds-button>
</div>
